/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetTenantFavIconRequest {
    tenantId: string;
    ifNoneMatch?: string | null;
}

/**
 * TenantFavIconProviderApi - interface
 * 
 * @export
 * @interface TenantFavIconProviderApiInterface
 */
export interface TenantFavIconProviderApiInterface {
    /**
     * It fetches the favicon of the tenant
     * @summary Get the tenant favicon
     * @param {string} tenantId 
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantFavIconProviderApiInterface
     */
    getTenantFavIconRaw(requestParameters: GetTenantFavIconRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * It fetches the favicon of the tenant
     * Get the tenant favicon
     */
    getTenantFavIcon(requestParameters: GetTenantFavIconRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class TenantFavIconProviderApi extends runtime.BaseAPI implements TenantFavIconProviderApiInterface {

    /**
     * It fetches the favicon of the tenant
     * Get the tenant favicon
     */
    async getTenantFavIconRaw(requestParameters: GetTenantFavIconRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantFavIcon().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/api/v1/tenant/{tenant_id}/favicon`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * It fetches the favicon of the tenant
     * Get the tenant favicon
     */
    async getTenantFavIcon(requestParameters: GetTenantFavIconRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getTenantFavIconRaw(requestParameters, initOverrides);
    }

}
